export const currencyMap: { [key: string]: string } = {
    'en-US': 'USD',
    'fr-FR': 'EUR',
    'sv-SE': 'SEK',
    'sv': 'SEK', // Add short code for Swedish
    // Add more mappings as needed
};

export const convertCurrency = (amount: number, fromCurrency: string, toCurrency: string, exchangeRates: { [key: string]: number }) => {
    if (!exchangeRates[toCurrency]) {
        return amount; // Fallback to the original amount if exchange rate is not available
    }
    const rate = exchangeRates[toCurrency];
    return amount * rate;
};

export const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'EUR', 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount).replace('EUR', '€');
};